import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { PageHeadline } from '../../../components/atoms';
import { ButtonStartOnboarding } from '../../Onboarding/components/BtnStartOnboarding/styleGuide';
import { ButtonTransferCompany } from '../../Onboarding/components/BtnTransfer/styleGuide';

import { useAppSelector } from '../../../hooks/hooksRedux';
import { RootState } from '../../../store';
import { clearDashboardTransferStepSession } from '../OnboardingOffshore/CompanyTransfer/constants';

export const ChooseOffshoreType = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { background, border } = useAppSelector((state: RootState) => state.styleGuide.data);

  const handleTransferExisting = () => {
    clearDashboardTransferStepSession();
    navigate('/dashboard/company-transfer');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-slate-50">
      <div className="mx-auto max-w-7xl px-6 py-8 lg:px-12">
        <PageHeadline
          title={t('titles.ttlChooseObjectives')}
          className="mt-8 shadow-xl"
          gradientFrom="from-primary"
          gradientTo="to-blue-800"
        />

        <div className="mt-10 flex justify-center">
          <div className="w-full max-w-3xl rounded-xl bg-white p-8 shadow-sm ring-1 ring-slate-900/5">
            <div className="flex flex-col gap-4 text-center md:flex-row md:justify-center">
              <ButtonStartOnboarding
                $backgroundColor={background.primary}
                $backgroundHover={background.hover}
                onClick={() => {
                  clearDashboardTransferStepSession();
                  navigate('/dashboard/create-offshore');
                }}
              >
                {t('titles.ttlCreateNewOffshore')}
              </ButtonStartOnboarding>
              <ButtonTransferCompany
                $borderColor={border.primary}
                $borderColorHover={border.hover}
                onClick={handleTransferExisting}
              >
                {t('titles.ttlTransferExistingOffshore')}
              </ButtonTransferCompany>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
